// extracted by mini-css-extract-plugin
export default {"tokensList":"tokensList--cf81n","label":"label--RnJdm","token":"token--pqN5B","tokenWrapper":"tokenWrapper--bkYtj","tokenString":"tokenString--NADZr"};